export default "__VITE_ASSET__BBheAdL0__"